import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  memo,
} from 'react';
import {
  SafeAreaView,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from 'react-native';
import {
  ActivityIndicator,
  Button,
  Divider,
  IconButton,
  List,
  Menu,
  TextInput,
} from 'react-native-paper';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {findBy, genExecCmd, getById, writeItem} from '../../api';
// import {genExecCmd} from '../../api/media';
import {useNavigation, useRoute} from '@react-navigation/native';
import {
  EncoderProject as EncoderProjectType,
  FFMpegOutputType,
  FFMpegPreset,
} from '../../types';
import {ScrollView} from 'react-native-gesture-handler';
import SyntaxHighlighter from 'react-native-syntax-highlighter';
import {xonokai} from 'react-syntax-highlighter/src/styles/prism';
import CodeEditor, {
  CodeEditorSyntaxStyles,
} from '@rivascva/react-native-code-editor';
import {ProjectParams} from '../../types/nav';
import {useAppDispatch} from '../../store/hooks';
import {setAppDialogParams} from '../../store/slices/ui';
import {useCloseDialog} from '../../hooks/useCloseDialog';
function EncoderProject(props?: {
  params?: ProjectParams;
  isEmbed?: true;
}) {
  //http://localhost:19006/webapp/editor/project/0c402cc0-8074-451c-ad46-18accc815879?encoder=e91f30c4-5b92-4e86-a111-f523f0ec4d17&mnemonic=wanderingtattler%20chimneyswift%20magenta%20magenta%20azure%20grasscarp%20whitelegshrimp%20pacificanchoveta%20encyrtidwasp%20interface%20port%20bus&parentFolderId=folder_4093327c-98c4-4959-8248-ebc5f426dc5c_16f88edc-6516-4dbb-a870-cb924cc6a9ca
  // const {writeItem} = props;
  const route = useRoute();
  const queryClient = useQueryClient();
  const [showCode, setShowCode] = useState(false);
  const params = props?.params || (route.params as ProjectParams);
  console.info('params', params);
  let {projectId, encoder, folderId, parentFolderId} = params || {};
  if (encoder) projectId = encoder;
  const project = useQuery(
    'project_' + projectId,
    async () => await getById(projectId, parentFolderId || folderId),
  );
  const [isMenuOpen, setMenu] = useState(false);
  const projectData: EncoderProjectType = project.data;
  // console.info('projectData', projectData);
  const afterWrite = useRef<number | undefined>();
  const codeEditorRef = useRef();
  const {height, width} = useWindowDimensions();
  const codeWidth = props.codeWidth || width - 200;
  const nav = useNavigation();
  const projectWriteMutation = useMutation(
    async (np: EncoderProjectType) => {
      // console.info('write', np);
      const ni = await writeItem(np);
      clearTimeout(afterWrite.current);
      afterWrite.current = setTimeout(() => {
        queryClient.refetchQueries({
          queryKey: 'folderContent_' + projectData?.folderId,
        });
        queryClient.refetchQueries({
          queryKey: ['projectdata', projectId],
        });
        queryClient.resetQueries({
          queryKey: ['encodedMedia', projectId],
          exact: true,
        });
        queryClient.resetQueries({
          queryKey: ['encodedFileSize', projectId],
          exact: true,
        });
        queryClient.resetQueries({
          queryKey: ['encodedFileSize', projectId],
          exact: true,
        });
        project.refetch();
        // nav.navigate('EditorProject', {
        //   ...params,
        // });
      }, 1000);
      return ni;
    },
  );
  const {closeDialog} = useCloseDialog();
  const dispatch = useAppDispatch();
  const onRemove = async () => {
    dispatch(
      setAppDialogParams({
        appDialogVisible: true,
        appDialogTitle: 'Delete Media',
        appDialogIcon: 'delete',
        appDialogOnSelectRight: async () => {
          await projectWriteMutation.mutateAsync({
            ...projectData,
            isDeleted: true,
          });
          closeDialog();
        },
        appDialogOnSelectLeftt: undefined,
        appDialogBody: 'This media will be removed from the project',
        appDialogControls: undefined,
        appDialogLoading: false,
      }),
    );
  };
  const [outputMenuVisible, setOutputMenuVisible] = useState(false);
  const [presetMenuVisible, setPresetMenuVisible] = useState(false);
  const outputTypes = Object.keys(FFMpegOutputType);
  const closeMenu = () => {
    setOutputMenuVisible(false);
    setPresetMenuVisible(false);
  };
  const selectValue = (
    valueType: keyof EncoderProjectType['encoding'],
    value: string | number,
  ) => {
    console.info('selectvalue', valueType);
    const np = projectData;
    const numericTypes = [
      'width',
      'compressionLevel',
      'height',
      'start',
      'end',
      'soundVolume',
    ];
    const nonRenderTypes = ['start', 'end', 'soundVolume'];
    const shouldRerender = !nonRenderTypes.includes(valueType);
    if (value === np.encoding[valueType]) return;
    if (numericTypes.includes(valueType) && isNaN(value)) {
      console.info('invalid type');
      return;
    }
    if (value === '') {
      return;
    }
    if (!np.encoding) {
      np.encoding = {};
    }
    np.encoding[valueType] = value;
    console.info(np);

    if (shouldRerender)
      np.encoding.lastUpdated = new Date().valueOf();

    projectWriteMutation.mutateAsync(np);
    // closeMenu();
  };
  if (project.isFetching) {
    return <ActivityIndicator size={72} />;
  }
  const execCmd = genExecCmd(projectData);
  const codeString = execCmd.join('\n');
  const fontSize = 12;
  const inputWidth = 120;
  return (
    <ScrollView
      style={{height: height / 2}}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}>
      <Divider key={'div00'} />
      <List.Item
        key={'info'}
        left={p => <List.Icon {...p} icon={'information'} />}
        title={projectData?.title}
        right={() => {
          return (
            <>
              <Menu
                anchor={
                  <IconButton
                    icon={'dots-vertical'}
                    onPress={() => setMenu(true)}
                  />
                }
                style={{marginTop: 50}}
                visible={isMenuOpen}
                onDismiss={() => setMenu(false)}>
                <>
                  <Menu.Item
                    leadingIcon={'delete'}
                    title={'Delete Item'}
                    onPress={onRemove}
                  />
                </>
              </Menu>
            </>
          );
        }}
      />
      <Divider key={'div01'} />
      <List.Item
        key={'start'}
        left={p => <List.Icon {...p} icon={'clock-plus'} />}
        title={'Start'}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <TextInput
              // dense={true}
              // mode="outlined"
              value={projectData?.encoding?.start?.toString() || '0'}
              style={{textAlign: 'right', pointerEvents: 'auto'}}
              keyboardType="numeric"
              onChangeText={text =>
                selectValue('start', parseFloat(text))
              }
            />
          </View>
        )}
      />
      <Divider key={'div7'} />
      <List.Item
        key={'end'}
        left={p => <List.Icon {...p} icon={'clock-minus'} />}
        title={`End (${projectData?.duration})`}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <TextInput
              // dense={true}
              // mode="outlined"
              value={(
                projectData?.encoding?.end || projectData?.duration
              )?.toString()}
              style={{textAlign: 'right', pointerEvents: 'auto'}}
              keyboardType="numeric"
              onChangeText={text =>
                selectValue('end', parseFloat(text))
              }
            />
          </View>
        )}
      />
      {/* <Divider key={'div4'} />
      <List.Item
        key={'cl'}
        left={p => <List.Icon {...p} icon={'zip-box'} />}
        title={'Compression'}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <TextInput
              dense={true}
              mode="outlined"
              value={projectData?.encoding?.compressionLevel}
              style={{textAlign: 'right', pointerEvents: 'auto'}}
              keyboardType="numeric"
              onChangeText={text =>
                selectValue('compressionLevel', parseInt(text, 10))
              }
            />
          </View>
        )}
      /> */}
      <Divider key={'divvolume'} />
      <List.Item
        key={'volume'}
        left={p => <List.Icon {...p} icon={'zip-box'} />}
        title={'Sound Volume'}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <TextInput
              // dense={true}
              // mode="outlined"
              value={(
                projectData?.encoding?.soundVolume || 100
              ).toString()}
              style={{textAlign: 'right', pointerEvents: 'auto'}}
              keyboardType="numeric"
              onChangeText={text =>
                selectValue('soundVolume', parseInt(text, 10))
              }
            />
          </View>
        )}
      />
      <Divider key={'div3'} />
      <List.Item
        key={'width'}
        left={p => <List.Icon {...p} icon={'ruler'} />}
        title={`Width(${projectData?.width})`}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <TextInput
              // dense={true}
              // mode="outlined"
              value={projectData?.encoding?.width?.toString()}
              style={{textAlign: 'right', pointerEvents: 'auto'}}
              keyboardType="numeric"
              onChangeText={text =>
                selectValue('width', parseInt(text, 10))
              }
            />
          </View>
        )}
      />
      <Divider key={'div2'} />
      <List.Item
        key={'height'}
        left={p => <List.Icon {...p} icon={'ruler'} />}
        title={`Height(${projectData?.height})`}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <TextInput
              // dense={true}
              // mode="outlined"
              value={projectData?.encoding?.height?.toString()}
              style={{textAlign: 'right', pointerEvents: 'auto'}}
              keyboardType="numeric"
              onChangeText={text =>
                selectValue('height', parseInt(text, 10))
              }
            />
          </View>
        )}
      />
      <Divider key={'div1'} />
      <List.Item
        key={'output'}
        left={p => <List.Icon {...p} icon={'file-export'} />}
        title={'Output'}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <Menu
              visible={outputMenuVisible}
              onDismiss={closeMenu}
              anchor={
                <Button
                  mode="outlined"
                  onPress={() => setOutputMenuVisible(true)}>
                  {projectData?.encoding?.output}
                </Button>
              }>
              <>
                {outputTypes.map(item => (
                  <Menu.Item
                    key={item}
                    onPress={() => selectValue('output', item)}
                    title={item}
                  />
                ))}
              </>
            </Menu>
          </View>
        )}
      />
      <Divider key={'div'} />
      <List.Item
        key={'preset'}
        left={p => <List.Icon {...p} icon={'cog'} />}
        title={'Preset'}
        titleStyle={{fontSize}}
        right={p => (
          <View style={{width: inputWidth}}>
            <Menu
              visible={presetMenuVisible}
              onDismiss={closeMenu}
              anchor={
                <Button
                  mode="outlined"
                  onPress={() => setPresetMenuVisible(true)}>
                  {projectData?.encoding?.preset}
                </Button>
              }>
              <>
                {Object.keys(FFMpegPreset).map(item => (
                  <Menu.Item
                    key={item}
                    onPress={() => selectValue('preset', item)}
                    title={item}
                  />
                ))}
              </>
            </Menu>
          </View>
        )}
      />
      {showCode === true ? (
        <View>
          <Divider key={'div5'} />
          <List.Item
            key={'code'}
            left={p => <List.Icon {...p} icon={'code-brackets'} />}
            title={''}
            titleStyle={{fontSize}}
            onPress={() => codeEditorRef?.current?.focus()}
            right={p => (
              <SafeAreaView style={{width: codeWidth, zIndex: 10}}>
                <CodeEditor
                  className={'codeEditor'}
                  ref={codeEditorRef}
                  style={{
                    fontSize,
                    inputLineHeight: fontSize,
                    highlighterLineHeight: fontSize,
                    display: 'flex',
                  }}
                  language="bash"
                  syntaxStyle={CodeEditorSyntaxStyles.xonokai}
                  initialValue={
                    projectData?.encoding?.code?.join(',') || ''
                  }
                  onChange={text => {
                    if (
                      text ===
                        projectData?.encoding?.code?.join(',') ||
                      ''
                    )
                      return;
                    selectValue('code', text.split(','));
                  }}
                  autoFocus={false}
                  showLineNumbers
                />
              </SafeAreaView>
            )}
          />
          <Divider key={'div6'} />
          {codeString && (
            <List.Item
              key={'output_code'}
              left={p => <List.Icon {...p} icon={'code-tags'} />}
              title=""
              titleStyle={{fontSize}}
              right={() => (
                <View style={{width: codeWidth}}>
                  <SyntaxHighlighter
                    language="bash"
                    style={xonokai}
                    highlighter={'prism'}
                    fontSize={fontSize}>
                    {codeString}
                  </SyntaxHighlighter>{' '}
                </View>
              )}
            />
          )}
          <Divider key={'div8'} />
        </View>
      ) : null}
      <Button
        icon={'code-brackets'}
        onPress={() => setShowCode(!showCode)}>
        Show FFMpeg Code
      </Button>
    </ScrollView>
  );
}

export default memo(EncoderProject);
